import { jsx as _jsx } from "react/jsx-runtime";
import { isEqual } from "lodash";
import React, { memo } from "react";
import { KEY_ENTER, KEY_SPACE } from "@config/constants";
var ForwardButton = function(param) {
    var disabled = param.disabled, getButtonsData = param.getButtonsData, onClick = param.onClick;
    var onKeyDownHandler = function(e) {
        e.stopPropagation();
        var key = e.which;
        if (key === KEY_SPACE || key === KEY_ENTER) {
            onClick(true);
        }
    };
    var buttonsData = getButtonsData();
    return /*#__PURE__*/ _jsx("div", {
        className: "forward-button player-button".concat(disabled ? " disabled" : ""),
        onClick: onClick,
        onKeyDown: onKeyDownHandler,
        tabIndex: "0",
        children: /*#__PURE__*/ _jsx("span", {
            className: "icon icon-forward-15 pointer",
            "data-for": "player-tooltip",
            "data-tip": buttonsData.forward.dataTip
        })
    });
};
var areEqual = function(prevProps, nextProps) {
    return isEqual(prevProps, nextProps);
};
export default /*#__PURE__*/ memo(ForwardButton, areEqual);
